/* import __COLOCATED_TEMPLATE__ from './sender-label.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import { EntityType } from 'embercom/models/data/entity-types';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import { type RenderableData } from 'embercom/objects/inbox/renderable-data';
interface Arguments {
  renderableData: RenderableData;
}

interface Signature {
  Args: Arguments;
}

export default class UnnamedComponent extends Component<Signature> {
  @service declare session: Session;
  entityType = EntityType;

  get isAdminComment() {
    return this.args.renderableData.creatingEntity.type === this.entityType.Admin;
  }

  get isFromOtherAdmin() {
    return (
      this.isAdminComment && this.args.renderableData.creatingEntity.id !== this.session.teammate.id
    );
  }

  get isFromTeam() {
    return this.args.renderableData.creatingEntity.type === this.entityType.Team;
  }

  get isFromBot() {
    return this.args.renderableData.creatingEntity.type === this.entityType.Bot;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::LeftNav::ConversationCard::SenderLabel': typeof UnnamedComponent;
    'inbox2/left-nav/conversation-card/sender-label': typeof UnnamedComponent;
  }
}
